import { Redirect } from 'react-router';
import { AppBar, Button, Toolbar, Typography } from '@material-ui/core';
import styles from './Login.module.css';
import React from 'react';

const Login = ({ signInWithGoogle, user }) => {
  return user ? (
    <Redirect to="/dashboard" />
  ) : (
    <div>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" color="inherit">
            DeWaste Dashboard
          </Typography>
        </Toolbar>
      </AppBar>
      <Button
        className={styles.loginButton}
        onClick={signInWithGoogle}
        variant="contained"
        style={{}}
      >
        <div className={styles.loginButtonInner}>
          <img
            src={'img/sign_in.svg'}
            alt={''}
            className={styles.loginButtonLogo}
          />
          <div>Sign in With Google</div>
        </div>
      </Button>
    </div>
  );
};

export default Login;
